// paramètres de l'animation
export const DURATION = 600;
export const DELAY = 300;
export const EASING = 'easeOutQuint';

// boutons du carousel
export const NEXT = document.querySelector('#next');
export const PREV = document.querySelector('#prev');
